import { render, staticRenderFns } from "./tail.vue?vue&type=template&id=08d5d14e&scoped=true&"
import script from "./tail.vue?vue&type=script&lang=js&"
export * from "./tail.vue?vue&type=script&lang=js&"
import style0 from "./tail.vue?vue&type=style&index=0&id=08d5d14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d5d14e",
  null
  
)

export default component.exports